import { useState, useCallback } from 'react';
import { message } from 'antd';
import {
  p9513Api,
  TripItem,
  EmpFilter,
  ApproveAction,
  ApproveResponse,
} from '../../../services/p9513Api';

export function useTripApproval() {
  const [loading, setLoading] = useState(false);
  const [approving, setApproving] = useState(false);
  const [trips, setTrips] = useState<TripItem[]>([]);
  const [total, setTotal] = useState(0);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const [filter, setFilter] = useState<EmpFilter>({ empStart: '', empEnd: '' });

  const fetchTrips = useCallback(async () => {
    setLoading(true);
    try {
      const data = await p9513Api.getTrips(filter);
      setTrips(data.items);
      setTotal(data.total);
      setSelectedKeys([]);
    } catch {
      message.error('查詢出差單失敗');
    } finally {
      setLoading(false);
    }
  }, [filter]);

  const batchApprove = useCallback(
    async (action: ApproveAction, remarks: string): Promise<ApproveResponse | null> => {
      if (selectedKeys.length === 0) {
        message.warning('請先選取要處理的出差單');
        return null;
      }
      setApproving(true);
      try {
        const resp = await p9513Api.approveTrips({
          trip_nos: selectedKeys,
          action,
          remarks,
        });
        const actionText = action === 'Y' ? '核准' : action === 'N' ? '拒絕' : '代理核准';
        message.success(`${actionText}完成：成功 ${resp.success} 筆，失敗 ${resp.failed} 筆`);
        setSelectedKeys([]);
        await fetchTrips();
        return resp;
      } catch {
        message.error('處理出差單失敗');
        return null;
      } finally {
        setApproving(false);
      }
    },
    [selectedKeys, fetchTrips]
  );

  return {
    loading,
    approving,
    trips,
    total,
    selectedKeys,
    setSelectedKeys,
    filter,
    setFilter,
    fetchTrips,
    batchApprove,
  };
}
